import { render, staticRenderFns } from "./tna-mitra.vue?vue&type=template&id=3b1b9d8f&scoped=true"
import script from "./tna-mitra.vue?vue&type=script&lang=js"
export * from "./tna-mitra.vue?vue&type=script&lang=js"
import style0 from "./tna-mitra.vue?vue&type=style&index=0&id=3b1b9d8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1b9d8f",
  null
  
)

export default component.exports